import { Injectable } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

const I18N_VALUES = {
  en: {
    weekdays: ['Su','Mo','Tu','We','Th','Fr','Sa'],
    monthsFull: ['January','February','March','April','May','June','July','August','September','October','November','December'],
    monthsShort: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
  },
  fr: {
    weekdays: ['Di','Lu','Ma','Me','Je','Ve','Sa'],
    monthsFull: ['Janvier','Février','Mars','Avril','Mai','Juin','Juillet','Août','Septembre','Octobre','Novembre','Décembre'],
    monthsShort: ['Janv.','Févr.','Mars','Avr.','Mai','Juin','Juil.','Août','Sept.','Oct.','Nov.','Déc.']
  },
  es: {
    weekdays: ['Do','Lu','Ma','Mi','Ju','Vi','Sa'],
    monthsFull: ['Enero','Febrero','Marzo','Abril','Mayo','Junio','Julio','Agosto','Septiembre','Octubre','Noviembre','Diciembre'],
    monthsShort: ['Ene','Feb','Mar','Abr','May','Jun','Jul','Ago','Sep','Oct','Nov','Dic']
  },
  ar: {
    weekdays: ['أح','إث','ثل','أر','خم','جم','سب'],
    monthsFull: ['يناير','فبراير','مارس','أبريل','مايو','يونيو','يوليو','أغسطس','سبتمبر','أكتوبر','نوفمبر','ديسمبر'],
    monthsShort: ['ينا','فبر','مار','أبر','ماي','يون','يول','أغس','سبت','أكت','نوف','ديس']
  }
};

@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {

  constructor(private translate: TranslateService){
    super();
  }

  private current(): keyof typeof I18N_VALUES {
    const lang = (this.translate.currentLang || this.translate.getDefaultLang() || 'en').split('-')[0];
    return (I18N_VALUES as any)[lang] ? lang as any : 'en';
  }

  // ng-bootstrap expects: Monday=1 ... Sunday=7
  getWeekdayShortName(weekday: number): string {
    const vals = I18N_VALUES[this.current()].weekdays;
    // Our arrays defined start with Sunday, so map Monday(1)->1 ... Saturday(6)->6, Sunday(7)->0
    const index = weekday === 7 ? 0 : weekday; // Monday=1, Sunday=7
    return vals[index];
  }

  getWeekdayLabel(weekday: number): string {
    return this.getWeekdayShortName(weekday);
  }

  getMonthShortName(month: number): string {
    return I18N_VALUES[this.current()].monthsShort[month - 1];
  }

  getMonthFullName(month: number): string {
    return I18N_VALUES[this.current()].monthsFull[month - 1];
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
}
